export const enumPermisosDavivienda = Object.freeze({
  DAVIVIENDA_CONVENIOS: 36016,
});
